<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Партнеры</strong>
                    <CLink to="/partners/archive" class="float-right">Архив</CLink>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading && partners">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CCard class="p-4 mt-2">
                            <CRow class="mb-1 ml-1 d-flex align-items-center justify-content-between">
                                <CCol class="h4 mb-0 p-0">Агентский отчет</CCol>
                                <CCol class="d-flex align-items-center justify-content-end">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="showFilters"
                                        class="ml-2" />
                                    <span class="ml-2">Настройки/Экспорт</span>
                                </CCol>
                            </CRow>
                            <CRow v-if="showFilters" class="ml-1 mb-1 align-items-center">
                                <CCol>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Показать оплату</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="showDifference"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Дата начала</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <DatePicker
                                                v-model="datepicker.dateFrom"
                                                :language="datepicker.lang"
                                                :format="datepicker.format"
                                                input-class="custom-datepicker"
                                                placeholder="Выберите дату..."
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Дата окончания</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <DatePicker
                                                v-model="datepicker.dateTo"
                                                :language="datepicker.lang"
                                                :format="datepicker.format"
                                                input-class="custom-datepicker"
                                                placeholder="Выберите дату..."
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Фильтровать по</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSelect
                                                :horizontal="true"
                                                class="w-full"
                                                input-class="form-control custom-datepicker mb-0"
                                                :value.sync="exportFilter"
                                                :options="exportFilterOptions"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Включить Отмененные/Инциденты</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="exportCanceled"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Выручка приходит к партнеру</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="partnerRevenue"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol
                                            cols="12"
                                            class="mt-2 flex">
                                            <CButton color="primary" :disabled="processStarted" @click="doExport">Экспорт</CButton>
                                            <CButton color="primary" class="ml-2" :disabled="processStarted" @click="doSendExport">Экспортировать и отправить всем получателям</CButton>
                                            
                                            <CButton color="success" class="ml-2" :disabled="processStarted" @click="doExportAll">Сводный отчет по всем партнерам</CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="processStarted" class="mt-2">
                                        <CCol cols="12" class="mt-2 flex">
                                            Процесс экспорта запущен. &nbsp;<CLink to="/export?type=partners">Перейти на страницу экспорта.</CLink>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                        </CCard>
                        <CDataTable
                            hover
                            striped
                            sorter
                            column-filter
                            :items="filteredItems"
                            :fields="fields"
                            :items-per-page="itemsPerPage"
                            :active-page="activePage"
                            :pagination="{ doubleArrows: true, align: 'center'}"
                            @page-change="pageChange"
                            class="table__partners"
                        >
                            <template #checkbox-filter>
                                <input
                                    id="select-all-page-partners"
                                    type="checkbox"
                                    :checked="allCurrentPageSelected"
                                    @change="toggleCurrentPagePartners"
                                />
                            </template>
                            <template #title-filter>
                                <CInput
                                    v-model="titleFilter"
                                    class="mb-0"
                                    type="text"
                                    placeholder="Поиск по имени"
                                />
                            </template>
                            <template #enabled-filter>
                                <CSelect
                                    :value.sync="enabledFilter"
                                    :options="enabledFilterOptions"
                                    class="mb-0"
                                />
                            </template>
                            <template #checkbox="data">
                                <td>
                                    <input v-model="selectedPartners" :value="data.item.id" type="checkbox" multiple />
                                </td>
                            </template>
                            <template #id="data">
                                <td>
                                    #{{ data.item.id }}
                                </td>
                            </template>
                            <template #title="data">
                                <td>
                                    <CLink :to="`/partners/${data.item.id}`">{{ data.item.title }}</CLink>
                                </td>
                            </template>
                            <template #enabled="data">
                                <td>
                                    <CBadge :color="getBadge(data.item.enabled)">
                                        {{ data.item.enabled ? 'Активен' : 'Неактивен' }}
                                    </CBadge>
                                </td>
                            </template>
                            <template #actions="data">
                                <td>
                                    <CButton
                                        color="danger"
                                        size="sm"
                                        :disabled="archivingId === data.item.id"
                                        @click="archivePartner(data.item)"
                                    >В архив</CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push('/partners/create')">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import DatePicker from 'vuejs-datepicker';
    import moment from 'moment';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import { ORDER_STATUS } from '../../utils/order';
    import { archiveServiceItem } from '@/utils/archive';

    export default {
        name: 'Partners',

        components: {
            DatePicker,
        },

        data() {
            return {
                loading: true,
                partners: [],
                selectedPartners: [],
                showFilters: false,
                processStarted: false,
                showDifference: false,
                itemsPerPage: 30,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                exportMessage: '',
                exportFile: '',
                exportFilter: ORDER_STATUS.DONE,
                exportFilterOptions: [
                    { value: ORDER_STATUS.DONE, label: 'По дате завершения' },
                    { value: ORDER_STATUS.PAID, label: 'По дате оплаты' },
                ],
                exportCanceled: false,
                partnerRevenue: false,
                titleFilter: '',
                enabledFilter: '',
                archivingId: null,
                enabledFilterOptions: [
                    { value: '', label: 'Все' },
                    { value: 'true', label: 'Активен' },
                    { value: 'false', label: 'Не активен' },
                ],
                fields: [
                    { key: 'checkbox', label: '', _classes: '' },
                    // { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'title', label: 'Название' },
                    { key: 'enabled', label: 'Активен' },
                    { key: 'actions', label: 'Действия', sorter: false, filter: false },
                ],
                activePage: 1,
            };
        },

        watch: {
            $route: {
                immediate: true,
                handler(route) {
                    if (route.query && route.query.page) {
                        this.activePage = Number(route.query.page);
                    }
                },
            },
        },

        async mounted() {
            this.loading = true;
            await Vue.axios
                .get('/partners')
                .then(resp => {
                    this.partners = resp.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            handleExportError(error) {
                const status = error?.response?.status;
                if (status === 409) {
                    this.$root.$emit('showError', 'Экспорт уже в работе. Дождитесь завершения текущей задачи.');
                    return;
                }
                this.$root.$emit('showError', 'Не удалось запустить экспорт. Попробуйте еще раз.');
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            async archivePartner(partner) {
                if (!window.confirm(`Переместить «${partner.title}» в архив?`)) {
                    return;
                }

                this.archivingId = partner.id;
                try {
                    await archiveServiceItem(Vue.axios, 'partners', partner);
                    this.partners = this.partners.filter(item => item.id !== partner.id);
                    this.selectedPartners = this.selectedPartners.filter(id => id !== partner.id);
                } catch (err) {
                    this.$root.$emit('showError', 'Не удалось переместить в архив.');
                } finally {
                    this.archivingId = null;
                }
            },
            getCurrentPagePartnerIds() {
                const start = (this.activePage - 1) * this.itemsPerPage;
                return this.filteredItems.slice(start, start + this.itemsPerPage).map(item => item.id);
            },
            toggleCurrentPagePartners(event) {
                const pagePartnerIds = this.getCurrentPagePartnerIds();
                if (!pagePartnerIds.length) {
                    return;
                }

                if (event.target.checked) {
                    const selected = new Set(this.selectedPartners);
                    pagePartnerIds.forEach(id => selected.add(id));
                    this.selectedPartners = Array.from(selected);
                    return;
                }

                const pagePartnerIdsSet = new Set(pagePartnerIds);
                this.selectedPartners = this.selectedPartners.filter(id => !pagePartnerIdsSet.has(id));
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
            async doExport({ sendToEmail = false }) {
                if (!this.selectedPartners.length) {
                    this.$root.$emit('showError', 'Выберите партнеров, для которых неободимо запустить импорт');
                    return;
                }
                if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                    return;
                }
                const filters = {
                    status: this.exportFilter,
                    canceled: this.exportCanceled,
                    partnerRevenue: this.partnerRevenue,
                }
                const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
                const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
                try {
                    await this.axios.get(
                        `/export/partners/list?selectedPartners=${this.selectedPartners.join(',')}&dateFrom=${dateFrom}&dateTo=${dateTo}&filter=${JSON.stringify(filters)}&difference=${this.showDifference}&sendToEmail=${sendToEmail}`
                    );
                    this.processStarted = true;
                } catch (error) {
                    this.handleExportError(error);
                }
            },
            doSendExport() {
                this.doExport({ sendToEmail: true });
            },
            async doExportAll({ sendToEmail = false }) {
                if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                    return;
                }
                const filters = {
                    status: this.exportFilter,
                    canceled: this.exportCanceled,
                    partnerRevenue: this.partnerRevenue
                }
                const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
                const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
                try {
                    await this.axios.get(
                        `/export/all-partners?dateFrom=${dateFrom}&dateTo=${dateTo}&filter=${JSON.stringify(filters)}&difference=${this.showDifference}&sendToEmail=${sendToEmail}`
                    );
                    this.processStarted = true;
                } catch (error) {
                    this.handleExportError(error);
                }
            },
        },
        computed: {
            filteredItemsByEnabled() {
                if (this.enabledFilter === '') {
                    return this.partners;
                }
                const enabled = this.enabledFilter === 'true';
                return this.partners.filter(item => item.enabled === enabled);
            },
            filteredItems() {
                return this.filteredItemsByEnabled.filter(item =>
                    item.title.toLowerCase().includes(this.titleFilter.toLowerCase())
                );
            },
            allCurrentPageSelected() {
                const pagePartnerIds = this.getCurrentPagePartnerIds();
                if (!pagePartnerIds.length) {
                    return false;
                }

                return pagePartnerIds.every(id => this.selectedPartners.includes(id));
            },
        },
    };
</script>

<style>
    .table__partners th,
    .table__partners td {
        padding: 0.75rem !important;
    }
</style>
